import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserRootComponent } from './user-root.component';
import { RouterModule } from '@angular/router';
import { FragmentsModule } from 'src/app/fragments/fragments.module';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from 'src/app/services/auth/auth.guard';
import { AlarmsComponent } from './alarms/alarms.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { RecherchePatientComponent, YearDateFormat } from './patient/recherche-patient/recherche-patient.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSortModule } from '@angular/material/sort';
import { MemosComponent } from './memos/memos.component';
import { AgendaComponent } from './agenda/agenda.component';
import { CalendarDateFormatter, CalendarEventTitleFormatter, CalendarModule, DateAdapter, MOMENT } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { CustomDateFormatter } from './agenda/formatter/date-formatter';
import * as moment from 'moment';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomEventTitleFormatter } from './agenda/formatter/event-title-formatter';
import { EventBoxFragment } from './agenda/event-box/event-box.fragment';
import { EventSearchComponent } from './agenda/event-search/event-search.component';
import { EventCreateComponent } from './agenda/event-create/event-create.component';
import { EventRecurrenceComponent } from './agenda/event-recurrence/event-recurrence.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NextSlotComponent } from './agenda/next-slot/next-slot.component';
import { EventConflictComponent } from './agenda/event-conflict/event-conflict.component';
import { SelectDeleteComponent } from './agenda/parameters/types/select-delete/select-delete.component';
import { DayWeekAsModelComponent } from './agenda/day-week-as-model/day-week-as-model.component';
import { MultiprofessionalMeetingComponent } from './multiprofessional-meeting/multiprofessional-meeting.component';
import { EditMeetingComponent } from './multiprofessional-meeting/edit-meeting/edit-meeting.component';
import { ModalPatientsToSeeInMeetingComponent } from '../../fragments/modal-patients-to-see-in-meeting/modal-patients-to-see-in-meeting.component';
import { ModalPatientsByAntecedentsComponent } from '../../fragments/modal-patients-by-antecedents/modal-patients-by-antecedents.component';
import { ModalPrintMeetingComponent } from './multiprofessional-meeting/edit-meeting/modal-print-meeting/modal-print-meeting.component';
import { CorrespondantsComponent } from './correspondants/correspondants.component';
import { MatMenuModule } from '@angular/material/menu';
import { AnnuaireComponent } from './correspondants/annuaire/annuaire.component';
import { QuillModule } from 'ngx-quill';
import { ModalSelectCaregiversComponent } from '../../fragments/modal-select-caregivers/modal-select-caregivers.component';
import { RechercheMultiComponent } from './recherche/recherche-multi/recherche-multi.component';
import { InputMaskModule } from 'racoon-mask-raw';
import { RechercheModule } from './recherche/recherche.module';
import { MultiprofessionalProtocolComponent } from './multiprofessional-protocol/multiprofessional-protocol.component';
import { EditProtocolComponent } from './multiprofessional-protocol/edit-protocol/edit-protocol.component';
// tslint:disable-next-line:max-line-length
import { ModalPrintProtocolComponent } from './multiprofessional-protocol/edit-protocol/modal-print-protocol/modal-print-protocol.component';
import { ModalSelectFileComponent } from './multiprofessional-protocol/edit-protocol/modal-select-file/modal-select-file.component';
import { AskForDateComponent } from './multiprofessional-protocol/edit-protocol/ask-for-date/ask-for-date.component';
import { AskForAppointmentComponent } from './multiprofessional-protocol/edit-protocol/ask-for-appointment/ask-for-appointment.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { NgxPaginationModule } from 'ngx-pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ContactComponent } from './contact/contact.component';
import { MssComponent } from './mss/inbox/mss.component';
import { AboutComponent } from './about/about.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { LogsApplicatifsComponent } from './logs-applicatifs/logs-applicatifs.component';
import { TableauDeBordComponent } from './tableau-de-bord/tableau-de-bord.component';
import { ReferentielsMedicauxComponent } from './referentiels-medicaux/referentiels-medicaux.component';
import { MssMenuRootModule } from './mss/mss-menu-root.module';
import { VerificationInsiComponent } from './verification-insi/verification-insi.component';
import { EPrescriptionComponent } from './e-prescription/e-prescription.component';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule }    from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { UserDocumentsComponent } from './user-documents/user-documents.component';


registerLocaleData(localeFr);

@NgModule({
  declarations: [
    UserRootComponent,
    HomeComponent,
    AlarmsComponent,
    RecherchePatientComponent,
    MemosComponent,
    YearDateFormat,
    AgendaComponent,
    EventBoxFragment,
    EventSearchComponent,
    EventCreateComponent,
    EventRecurrenceComponent,
    NextSlotComponent,
    EventConflictComponent,
    SelectDeleteComponent,
    DayWeekAsModelComponent,
    MultiprofessionalMeetingComponent,
    EditMeetingComponent,
    ModalPatientsToSeeInMeetingComponent,
    ModalPatientsByAntecedentsComponent,
    ModalPrintMeetingComponent,
    CorrespondantsComponent,
    AnnuaireComponent,
    ModalSelectCaregiversComponent,
    MultiprofessionalProtocolComponent,
    EditProtocolComponent,
    ModalPrintProtocolComponent,
    ModalSelectFileComponent,
    AskForDateComponent,
    AskForAppointmentComponent,
    LogsApplicatifsComponent,
    TableauDeBordComponent,
    ReferentielsMedicauxComponent,
    VerificationInsiComponent,
    UserDocumentsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FragmentsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    NgSelectModule,
    RechercheModule,
    MatExpansionModule,
    MatSortModule,
    // On importe MssMenuRootModule pour avoir les popups connect mailiz et connect apicrypt, et presend clinical document fonctionnelles
    MssMenuRootModule,
    RouterModule.forChild([
      {
        path: '',
        component: UserRootComponent,
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full'
          },
          {
            path: 'home',
            component: HomeComponent
          },
          {
            path: 'alarm',
            component: AlarmsComponent
          },
          {
            path: 'contact',
            component: ContactComponent
          },
          {
            path: 'memo',
            component: MemosComponent
          },
          {
            path: 'correspondant',
            component: CorrespondantsComponent
          },
          {
            path: 'correspondant/annuaire',
            component: AnnuaireComponent
          },
          {
            path: 'settings',
            loadChildren: () => import('./user-settings/user-settings-root.module').then(m => m.UserSettingsRootModule)
          },
          {
            path: 'office',
            loadChildren: () => import('./office-settings/office-root.module').then(m => m.OfficeRootModule)
          },
          {
            path: 'patient',
            component: RecherchePatientComponent
          },
          {
            path: 'patient/:id',
            loadChildren: () => import('./patient/dossier-patient/dossier-root.module').then(m => m.DossierRootModule)
          },
          {
            path: 'agenda',
            component: AgendaComponent,
          },
          {
            path: 'agenda/search',
            component: EventSearchComponent,
          },
          {
            path: 'agenda/create',
            component: EventCreateComponent,
          },
          {
            path: 'agenda/update/:eventId',
            component: EventCreateComponent,
          },
          {
            path: 'agenda/duplicate/:eventId',
            component: EventCreateComponent,
          },
          {
            path: 'agenda/parameters/:resourceId/:resourceType',
            loadChildren: () => import('./agenda/parameters/parameters-root.module').then(m => m.ParametersRootModule)
          },
          {
            path: 'agenda/repeat-model',
            component: DayWeekAsModelComponent,
          },
          {
            path: 'user/reunions',
            component: MultiprofessionalMeetingComponent,
          },
          {
            path: 'user/reunions/edit/:meetingId',
            component: EditMeetingComponent,
          },
          {
            path: 'user/reunions/edit',
            component: EditMeetingComponent,
          },
          {
            path: 'recherche',
            component: RechercheMultiComponent,
          },
          {
            path: 'user/recherche-eprescrition',
            component: EPrescriptionComponent,
          },
          {
            path: 'personnalisation',
            loadChildren: () => import('./personnalisation/personnalisation-root.module').then(m => m.PersonnalisationRootModule)
          },
          {
            path: 'parametres',
            loadChildren: () => import('./parametres/parametres-root.module').then(m => m.ParametresRootModule)
          },
          {
            path: 'about',
            component: AboutComponent,
          },
          {
            path: 'user/protocoles',
            component: MultiprofessionalProtocolComponent,
          },
          {
            path: 'logs-applicatifs',
            component: LogsApplicatifsComponent,
          },
          {
            path: 'tableau-de-bord',
            component: TableauDeBordComponent,
          },
          {
            path: 'referentiels-medicaux',
            component: ReferentielsMedicauxComponent,
          },
          {
            path: 'verification-insi-en-masse',
            component: VerificationInsiComponent,
          },
          {
            path: 'user/protocoles/edit/:protocolId',
            component: EditProtocolComponent,
          },
          {
            path: 'user/protocoles/edit',
            component: EditProtocolComponent,
          },
          {
            path: 'user/messagerie',
            loadChildren: () => import('./mss/mss-menu-root.module').then(m => m.MssMenuRootModule)
          },
          {
            path: 'utilitaires',
            loadChildren: () => import('./utilitaires/utilitaires.module').then(m => m.UtilitairesModule)
          },
          {
            path: 'compta',
            loadChildren: () => import('./compta/compta-root.module').then(m => m.ComptaRootModule)
          },
          {
            path: 'detachedDocuments',
            loadChildren: () => import('./detached-documents/detached-documents.module').then(m => m.DetachedDocumentsModule)
          },
          { path: 'test',
            component: MssComponent
          },
          { path:'user-documents',
            component: UserDocumentsComponent
          }
        ]
      }
    ]),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory
    }),
    NgxMaterialTimepickerModule.setLocale('fr-FR'),
    NgSelectModule,
    QuillModule.forRoot(),
    InputMaskModule,
    MatTreeModule,
    MatIconModule,
    NgxPaginationModule,
    DragDropModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule,
    MatToolbarModule,
    MatCardModule,
    MatButtonToggleModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    MatDialogModule,
    FroalaEditorModule.forRoot(),
    FroalaViewModule.forRoot()
  ],
  providers: [
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'fr-FR'
    },
    {
      provide: MOMENT,
      useValue: moment
    },
    {
      provide: CalendarDateFormatter,
      useClass: CustomDateFormatter
    },
    {
      provide: CalendarEventTitleFormatter,
      useClass: CustomEventTitleFormatter
    }
  ]
})
export class UserRootModule { }
